// extracted by mini-css-extract-plugin
export default {"container":"fOYMf_Xh_A6Ah5tZ0ori"};